import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// eslint-disable-next-line import/no-cycle
import FileService from 'services/api/file.service';
import { ICommonCallbackPayload } from 'types/common';

import { StandardAction } from '../types';
import FileAction from './file.actions';
import { IFileActionDispatchPayload, IUploadDocument } from './types';

const { UPLOAD_FILE, UPLOAD_DOCUMENT } = FileAction.TYPES;

// placeholder for update file saga
function* uploadFile(action: StandardAction<{ data: IFileActionDispatchPayload; callback?: ICommonCallbackPayload }>) {
  const { payload } = action;
  if (payload) {
    try {
      if (payload.data.files.length) {
        yield call(FileService.uploadFile, payload.data);
        yield put(FileAction.uploadFileSuccess());
        payload.callback?.callbackOnSuccess?.();
      } else {
        payload.callback?.callbackOnFailure?.("File's size is too large");
      }
    } catch (error) {
      // notification.error({
      //   message: error,
      // });
      payload.callback?.callbackOnFailure?.(error.message);
      yield put(FileAction.uploadFileError(error));
    }
  }
}

function* uploadDocument(
  action: StandardAction<{ data: IUploadDocument; callback?: ICommonCallbackPayload }>,
): Generator<any, any, any> {
  const { payload } = action;
  if (payload) {
    try {
      if (payload.data.files.length) {
        yield call(FileService.uploadTransactionDocument, payload.data);
        yield put(FileAction.uploadFileSuccess());
        payload.callback?.callbackOnSuccess?.();
      } else {
        payload.callback?.callbackOnFailure?.("File's size is too large");
      }
    } catch (error) {
      // notification.error({
      //   message: error,
      // });
      payload.callback?.callbackOnFailure?.(error.message);
      yield put(FileAction.uploadFileError(error));
    }
  }
}

function* watchUploadFile() {
  yield takeEvery(UPLOAD_FILE.START, uploadFile);
  yield takeEvery(UPLOAD_DOCUMENT.START, uploadDocument);
}

export default function* rootSaga(): Generator {
  yield all([fork(watchUploadFile)]);
}
